import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import UserInfoModalContext from '../../../data_system/contexts/user_context/user_info_modal_context';

import UserModal from '../../UserComponents/UserModal';
import RefreshCheckApi from '../../../communication_system/axios_apis/refresh_check/refresh_check_api';
import { Wrapper02 } from '../../../designComponents/wrappers/FlexMainWrapper';
import { DefaultModal } from '../../../designComponents/modals/ModalComponent';
import DesignTable from '../../../designComponents/tables/DesignTable';
import { Image } from '../../../designComponents/imageboxs/Image';
import { sexFilter } from '../../../utils/textFilter';
import { CustomCloseOutlined, ImageModalWrapper, ModalImage } from '../../styles/GatheringDetailComponentStyled';
import { ExcelButton, MainButton } from '../../../designComponents/buttons/Buttons';
import { main_server_ip } from '../../../communication_system/communication_ips';
import axios from 'axios';
import { buildScheduleParticipantCancelPayload, isScheduleParticipantCancelable } from './scheduleParticipantCancel';
import { onClickExcelFormat } from '../../../utils/xlsxUtil';
import {
    buildScheduleParticipantOptions,
    EMPTY_SCHEDULE_PARTICIPANT_FILTERS,
    filterScheduleParticipants,
    SCHEDULE_PARTICIPANT_EXCEL_HEADERS,
    scheduleParticipantExcelRows,
} from './scheduleParticipantManagement';

import PayInfoDetailModal from '../../SyrupComponents/PayInfoDetailModal';

const JoinUserListsModal = ({ contentsId, owner_id, searchJoinUserToggle, setSearchJoinUserToggle }) => {
    const { user_info_modal_actions } = useContext(UserInfoModalContext);
    const { user_info_modal_state } = useContext(UserInfoModalContext);

    const [joinUserLists, setJoinUserLists] = useState([]);
    const [imageToggle, setImageToggle] = useState(false);
    const [src, setSrc] = useState('');
    const [payInfoDetailToggle, setPayInfoDetailToggle] = useState([false, 0]);
    const [scheduleRefundContext, setScheduleRefundContext] = useState(null);
    const [filters, setFilters] = useState({ ...EMPTY_SCHEDULE_PARTICIPANT_FILTERS });
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState('');

    const currentTarget = useRef();

    const [myInfo, setMyInfo] = useState({});
    const adminCheckAPI = async () => {
        const reseponse = await RefreshCheckApi.get('/admin/check');
        const adminInfo = reseponse.data.info;
        setMyInfo(adminInfo);
    };

    useEffect(() => {
        adminCheckAPI();
    }, []);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setLoadError('');
        setFilters({ ...EMPTY_SCHEDULE_PARTICIPANT_FILTERS });

        RefreshCheckApi.get(`/adminGathering/schedule/users?contents_id=${contentsId}`)
            .then((res) => {
                if (!Array.isArray(res?.data?.data)) throw new Error('invalid participant response');
                if (active) setJoinUserLists(res.data.data);
            })
            .catch(() => {
                if (!active) return;
                setJoinUserLists([]);
                setLoadError('참여회원 정보를 불러오지 못했습니다. 잠시 후 다시 열어주세요.');
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        return () => {
            active = false;
        };
    }, [contentsId]);

    const filteredJoinUserLists = useMemo(() => filterScheduleParticipants(joinUserLists, filters), [joinUserLists, filters]);
    const payStatusOptions = useMemo(() => buildScheduleParticipantOptions(joinUserLists, 'pay_status_number', 'pay_status'), [joinUserLists]);
    const payTypeOptions = useMemo(() => buildScheduleParticipantOptions(joinUserLists, 'pay_type_number', 'pay_type'), [joinUserLists]);

    const onChangeFilter = (key) => (event) => {
        setFilters((current) => ({ ...current, [key]: event.target.value }));
    };

    const onResetFilters = () => setFilters({ ...EMPTY_SCHEDULE_PARTICIPANT_FILTERS });

    const onDownloadExcel = () => {
        if (filteredJoinUserLists.length === 0) {
            alert('다운로드할 참여회원이 없습니다.');
            return;
        }
        onClickExcelFormat(SCHEDULE_PARTICIPANT_EXCEL_HEADERS, scheduleParticipantExcelRows(filteredJoinUserLists), `일정_${contentsId}_참여회원.xlsx`);
    };

    // ESC로 창 닫기
    useEffect(() => {
        const escKeyModalClose = (e) => {
            if (e.keyCode === 27) {
                if (user_info_modal_state.modalVisible) {
                    user_info_modal_actions.setModalVisible(false);
                } else {
                    setSearchJoinUserToggle(false);
                }
            }
        };
        window.addEventListener('keydown', escKeyModalClose);
        return () => window.removeEventListener('keydown', escKeyModalClose);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user_info_modal_state, searchJoinUserToggle]);

    // 클릭 감지
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    // 이미지 모달 외부 클릭 시 Modal창 닫힘
    const handleClickOutside = (event) => {
        if (!currentTarget.current) {
            return;
        } else {
            if (currentTarget && !currentTarget.current.contains(event.target)) {
                setImageToggle((prev) => !prev);
            }
        }
    };

    const onClickUserDetail = (item) => {
        user_info_modal_actions.setId(item.id);
        user_info_modal_actions.setModalVisible(true);
    };

    const onClickGetToken = async (serverUrl, adminId) => {
        try {
            const _url = serverUrl;
            const response = await RefreshCheckApi.post(_url + '/auth/testLogin', {
                id: adminId,
            });
            const token = response.data.data.access_token;
            return token;
        } catch (error) {
            console.error('error: ', error);
        }
    };

    const onCancelDate = (item) => {
        if (!isScheduleParticipantCancelable(item.pay_status_number)) {
            alert('입금 대기만 참석 취소 가능합니다.');
            return false;
        }

        onClickGetToken(main_server_ip, myInfo.id).then((token) => {
            const response = axios.post(main_server_ip + '/adminGathering/schedule/cancel', buildScheduleParticipantCancelPayload(item), {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            response
                .then((res) => {
                    alert('일정 참석 취소가 완료되었습니다.');
                })
                .catch((error) => {
                    console.error(error);
                    alert(`에러발생: ${error.response.data.message}`);
                })
                .finally(() => {
                    setSearchJoinUserToggle(false);
                });
        });
    };

    const refreshJoinUserLists = async () => {
        const response = await RefreshCheckApi.get(`/adminGathering/schedule/users?contents_id=${contentsId}`);
        if (!Array.isArray(response?.data?.data)) throw new Error('invalid participant response');
        setJoinUserLists(response.data.data);
    };

    return (
        <DefaultModal
            title="참여회원 관리"
            windowStyle={{ alignItems: 'stretch', justifyContent: 'stretch' }}
            boxStyle={{ width: '100vw', height: '100vh', borderRadius: 0 }}
            onClickClose={() => setSearchJoinUserToggle(false)}
            onClickBottomClose={() => setSearchJoinUserToggle(false)}
            bodyWidth={87}
            bottomBtnOn
            closeOn
            cancelText={'닫기'}
        >
            <Wrapper02 style={{ minHeight: '100%', padding: '20px', marginBottom: 0, borderRadius: 0 }}>
                {user_info_modal_state.modalVisible ? <UserModal setImageToggle={setImageToggle} setSrc={setSrc} /> : null}
                {payInfoDetailToggle[0] && (
                    <PayInfoDetailModal
                        payInfoDetailToggle={payInfoDetailToggle}
                        setToggle={setPayInfoDetailToggle}
                        type="모임"
                        refresh={refreshJoinUserLists}
                        adminScheduleRefund
                        scheduleRefundContext={scheduleRefundContext}
                    />
                )}
                {imageToggle && (
                    <ImageModalWrapper>
                        <CustomCloseOutlined onClick={() => {}} />
                        <ModalImage src={src} alt="크게보기 이미지" ref={currentTarget} />
                    </ImageModalWrapper>
                )}
                <Toolbar>
                    <SearchInput aria-label="참여회원 검색" value={filters.query} onChange={onChangeFilter('query')} placeholder="ID, 이름, 닉네임, 휴대폰번호, 관리자 메모 검색" />
                    <MainButton text="필터 초기화" styleReverse onClick={onResetFilters} />
                    <ExcelButton text="Excel 다운로드" width={120} onClick={onDownloadExcel} />
                    <ResultCount aria-live="polite">조회 {filteredJoinUserLists.length}명</ResultCount>
                </Toolbar>

                {loading && <StatusMessage>참여회원 정보를 불러오는 중입니다.</StatusMessage>}
                {!loading && loadError && <ErrorMessage role="alert">{loadError}</ErrorMessage>}
                {!loading && !loadError && filteredJoinUserLists.length === 0 && <StatusMessage>조건에 맞는 참여회원이 없습니다.</StatusMessage>}
                {!loading && !loadError && (
                    <DesignTable
                        marginTop={0.5}
                        onToggle={null}
                        modalComponent={false}
                        header={[
                            { title: 'ID', width: 80 },
                            { title: '회원명', width: 80 },
                            { title: '닉네임', width: 110 },
                            {
                                title: (
                                    <ColumnFilter
                                        label="성별"
                                        ariaLabel="성별 필터"
                                        value={filters.sex}
                                        onChange={onChangeFilter('sex')}
                                        options={[
                                            { value: '1', label: '남자' },
                                            { value: '2', label: '여자' },
                                        ]}
                                    />
                                ),
                                width: 90,
                            },
                            { title: '생년월일', width: 100 },
                            { title: '휴대폰번호', width: 120 },
                            {
                                title: <ColumnFilter label="결제 상태" ariaLabel="결제 상태 필터" value={filters.payStatus} onChange={onChangeFilter('payStatus')} options={payStatusOptions} />,
                                width: 130,
                            },
                            { title: <ColumnFilter label="결제 방법" ariaLabel="결제 방법 필터" value={filters.payType} onChange={onChangeFilter('payType')} options={payTypeOptions} />, width: 130 },
                            { title: '프로필 이미지', width: 100 },
                            { title: '관리자 메모', width: 180 },
                            {
                                title: (
                                    <ColumnFilter
                                        label="취소 여부"
                                        ariaLabel="취소 여부 필터"
                                        value={filters.cancelStatus}
                                        onChange={onChangeFilter('cancelStatus')}
                                        options={[
                                            { value: 'active', label: '정상' },
                                            { value: 'cancelled', label: '참여 취소' },
                                        ]}
                                    />
                                ),
                                width: 120,
                            },
                        ]}
                        body={[
                            { key: 'id', width: 80 },
                            { key: 'name', width: 80 },
                            { key: 'nick_name', width: 110 },
                            { key: 'sex', width: 70 },
                            { key: 'birthday', width: 100 },
                            { key: 'phone_no', width: 120 },
                            { key: 'pay_status', width: 100 },
                            { key: 'pay_type', width: 100 },
                            { key: 'url', width: 100 },
                            { key: 'admin_memo', width: 180 },
                            { key: 'cancel_action', width: 100 },
                        ]}
                        data={filteredJoinUserLists}
                        allCount={0}
                        wrapper={{ width: '100%', margin: 'auto' }}
                        rowTextStyle={{ borderLeft: '0px' }}
                        bodyRederItem={(key, value, item) => {
                            const resolvedOwnerId = owner_id ?? item.owner_id;
                            if (key === 'id') return <span style={{ padding: '20px 0' }}>{value}</span>;
                            if (key === 'name')
                                return (
                                    <span style={{ padding: '20px 0', color: resolvedOwnerId === item.id ? 'red' : '', fontWeight: resolvedOwnerId === item.id ? 'bold' : '' }}>
                                        {value}
                                        {resolvedOwnerId === item.id ? '(주최자)' : null}
                                    </span>
                                );
                            if (key === 'sex') return sexFilter(value);
                            if (key === 'url') return <Image url={value} width={80} height={80} onClick={() => onClickUserDetail(item)} />;
                            if (key === 'admin_memo') return <MemoText>{value || '-'}</MemoText>;
                            if (key === 'cancel_action') {
                                if (Number(item.pay_status_number) === 8) return '참여 취소';
                                if (Number(item.pay_status_number) === 1) return <MainButton onClick={() => onCancelDate(item)} text={'취소 처리'} />;
                                if (Number(item.pay_status_number) === 2)
                                    return (
                                        <MainButton
                                            onClick={() => {
                                                setScheduleRefundContext({ payId: Number(item.pay_id), userId: Number(item.id), contentsId: Number(contentsId) });
                                                setPayInfoDetailToggle([true, item.pay_id]);
                                            }}
                                            text={'환불/취소'}
                                        />
                                    );
                                return '불가능';
                            }
                            return <span>{value}</span>;
                        }}
                        noneText="참여회원이 존재하지 않습니다."
                        noneHieght={25}
                    />
                )}
            </Wrapper02>
        </DefaultModal>
    );
};

export default JoinUserListsModal;

const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 12px;
    text-align: left;
`;

const SearchInput = styled.input`
    min-width: 300px;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #c7c7c7;
    border-radius: 4px;
`;

const ColumnFilter = ({ label, ariaLabel, value, onChange, options }) => (
    <ColumnFilterWrapper>
        <span>{label}</span>
        <ColumnFilterSelect aria-label={ariaLabel} value={value} onChange={onChange}>
            <option value="">전체</option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </ColumnFilterSelect>
    </ColumnFilterWrapper>
);

const ColumnFilterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
`;

const ColumnFilterSelect = styled.select`
    height: 28px;
    min-width: 90px;
    padding: 0 24px 0 6px;
    border: 1px solid #c7c7c7;
    border-radius: 4px;
    background-color: #fff;
    font-size: 12px;
`;

const ResultCount = styled.span`
    margin-left: auto;
    font-weight: 600;
`;

const StatusMessage = styled.div`
    padding: 40px 0;
    color: #797979;
`;

const ErrorMessage = styled(StatusMessage)`
    color: #c62828;
`;

const MemoText = styled.span`
    display: inline-block;
    min-width: 160px;
    max-width: 280px;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;
`;
